export default () => ({
  field: {
    paddingBottom: 20,
    maxWidth: 250,
  },
});
